import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=e4a2a8e0&"
import script from "./CategoryItem.vue?vue&type=script&lang=js&"
export * from "./CategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/84/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4a2a8e0')) {
      api.createRecord('e4a2a8e0', component.options)
    } else {
      api.reload('e4a2a8e0', component.options)
    }
    module.hot.accept("./CategoryItem.vue?vue&type=template&id=e4a2a8e0&", function () {
      api.rerender('e4a2a8e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/klettershop/CategoryItem.vue"
export default component.exports